import global from "global";

const sdkExists = sdkName => global.asos?.sdk[sdkName];

const sdkInstanceProvider = sdkName =>
  new Promise(resolve => {
    const resolveSdk = () => {
      const sdk = global.asos.sdk[sdkName];
      resolve(sdk);
    };

    if (sdkExists(sdkName)) {
      return resolveSdk();
    }

    global.asos.eventBus.once(`${sdkName}-sdk-ready`, resolveSdk);
  });

export default sdkInstanceProvider;
